import { Controller } from "@hotwired/stimulus";

// Manages custom HTTP headers in webhook form
export default class extends Controller {
  static targets = ["container", "row", "input"];
  static values = { initial: String };

  connect() {
    this.updateHiddenField();
  }

  addRow() {
    const row = this.createRow("", "");
    this.containerTarget.appendChild(row);
    this.updateHiddenField();
  }

  removeRow(event) {
    event.target.closest("[data-headers-target='row']").remove();
    this.updateHiddenField();
  }

  update() {
    this.updateHiddenField();
  }

  createRow(key, value) {
    const row = document.createElement("div");
    row.className = "flex gap-2";
    row.setAttribute("data-headers-target", "row");
    row.innerHTML = `
      <input
        type="text"
        placeholder="Header name"
        value="${key}"
        data-action="input->headers#update"
        data-role="key"
        class="form-input flex-1"
      >
      <input
        type="text"
        placeholder="Header value"
        value="${value}"
        data-action="input->headers#update"
        data-role="value"
        class="form-input flex-1"
      >
      <button
        type="button"
        data-action="click->headers#removeRow"
        class="text-gray-400 hover:text-red-500"
      >
        <i class="fa-regular fa-times"></i>
      </button>
    `;
    return row;
  }

  updateHiddenField() {
    const headers = {};
    this.rowTargets.forEach((row) => {
      const keyInput = row.querySelector('[data-role="key"]');
      const valueInput = row.querySelector('[data-role="value"]');
      const key = keyInput.value.trim();
      const value = valueInput.value.trim();
      if (key && value) {
        headers[key] = value;
      }
    });

    // Find the hidden field in the form
    const form = this.element.closest("form");
    const hiddenField = form.querySelector(
      'input[type="hidden"][name*="headers"]',
    );
    if (hiddenField) {
      hiddenField.value = JSON.stringify(headers);
    }
  }
}
